import React from "react";
import { useSelector } from "react-redux";

import Modal from "./Modal";
import CustomSpinner from "components/Loader/CustomSpinner";
import {
  MODAL_CLOSE,
  COMPLETE_TRANSACTION,
  FAILED_TRANSACTION,
} from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";

const Loader = ({ name, nameChangeCost, icxInUSD }) => (
  <>
    <div className="header">
      <h4 className="mb-2">Wallet connected!</h4>
      <p className="text">
        Total Price: <strong> {replaceFloatValue(nameChangeCost)} $GBET</strong>
      </p>
    </div>
    <div className="body loading">
      <CustomSpinner />
    </div>
    <div className="footer">
      <p className="py-2">
        Changing name to <strong>{name}</strong> for{" "}
        {replaceFloatValue(nameChangeCost)} $GBET. <br /> Please wait for a
        moment.
      </p>
      <button disabled className="btn btn-outline-secondary close">
        Close
      </button>
    </div>
  </>
);

const Success = ({ onClick, name }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="heading">
      <h4 className="mb-3">Congratulations !</h4>
      <p className="text">
        You successfully changed the name to <strong>{name}.</strong>
        <br />
      </p>
    </div>
    <div className="body">
      <img
        src={COMPLETE_TRANSACTION.SOURCE}
        alt="transaction completed"
        className="d-block mx-auto my-3"
      />

      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Error = ({ onClick, message }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="heading">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Failed</h4>
      <p className="text my-3">
        Could not change name due to transaction failure, please try again after
        sometime!
        <br />
        {message}
      </p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Cancel = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Cancelled</h4>
      <p className="text my-3">Transaction cancelled.</p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const ChangeNameModal = ({
  success,
  onClick,
  name,
  nameChangeCost,
  isVisible,
}) => {
  const icxInUSD = useSelector((state) => state.icxPricing.price);

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="buying-modal card px-3 py-4"
    >
      {success.status === "success" ? (
        <Success onClick={onClick} name={name} />
      ) : success.status === "error" ? (
        <Error onClick={onClick} message={success.msg} />
      ) : success.status == "cancel" ? (
        <Cancel onClick={onClick} />
      ) : (
        <Loader
          name={name}
          nameChangeCost={nameChangeCost}
          icxInUSD={icxInUSD}
        />
      )}
    </Modal>
  );
};

export default ChangeNameModal;
